module.exports = __webpack_public_path__ + "img/image 12.e33624bf.png";